import React, { useState, useEffect } from 'react';
import { Link, Stack, Typography } from '@mui/material';
import CusInput from '../../../../../components/material-ui/CusInput';
import TypographyText from '../../../../../components/material-ui/table/TypographyText';
import { useTranslation } from 'react-i18next';
import CusCheckbox from '../../../../../components/material-ui/CusCheckbox';
import CasinoBtnSave from '../../../../../components/casino/CasinoBtnSave';
import { API_CASINO } from '../../../../../api/casino';
import useNumberParams from '../../../../../hooks/useNumberParams';
import CusLink from '../../../../../components/material-ui/CusLink';

export default function ManagerTgNotifyContent() {
  const { t } = useTranslation();
  const casinoId = useNumberParams('casinoId');

  const [tgIds, setTgIds] = useState('');
  const [checks, setChecks] = useState([]);

  const actions = [
    { id: 'regNewUser', text: 'New user registered' },
    { id: 'depError', text: 'Gateway error when creating a deposit' },
    { id: 'depInprocess', text: 'Deposit "in processing"' },
    { id: 'depPaid', text: 'Deposit in "paid"' },
    { id: 'outCreated', text: 'Withdrawal request "created"' },
    { id: 'outPaidOut', text: 'Withdrawal request "paid"' },
    { id: 'depLock', text: 'Blocking the creation of deposits' },
    { id: 'pcodeActivate', text: 'Promotional code activated' },
    { id: 'pcodeWagered', text: 'The promo code has been redeemed' }
  ];

  useEffect(() => {
    API_CASINO.tgNotify.managers
      .get({ casinoId })
      .then((e) => {
        const data = e.data.data;
        const eventKeys = Object.entries(data.eventList)
          .filter(([key, value]) => value === true)
          .map(([key]) => key);

        setTgIds(data.tgIdList.join(','));
        setChecks(eventKeys);
      })
      .catch(console.error);
  }, [casinoId]);

  const onSaveClick = () => {
    console.log('checks', tgIds, checks);

    const eventList = actions.reduce((acc, action) => {
      acc[action.id] = checks.includes(action.id);
      return acc;
    }, {});

    const data = {
      tgIdList: tgIds.split(',').map((el) => +el),
      eventList: eventList
    };
    API_CASINO.tgNotify.managers
      .set({ casinoId, data })
      .then((e) => {})
      .catch(console.error);
  };

  return (
    <Stack gap={1}>
      <CusInput
        label={'Telegram IDs'}
        value={tgIds}
        onChange={(e) => setTgIds(e.target.value)}
        placeholder={'1,2,3,1001'}
        tooltipText={
          <TypographyText>
            {t('List the managers IDs separated by commas')}{' '}
            {t('You can find out your Telegram ID in the bot')}{' '}
            <CusLink
              linkComponent={'a'}
              href="https://t.me/userinfobot"
              color="primary"
              target="_blank"
              text="@userinfobot"></CusLink>
          </TypographyText>
        }
      />
      <Stack gap={0}>
        {actions.map((action) => (
          <CusCheckbox
            key={action.id}
            variant="span"
            title={action.text}
            checked={checks.includes(action.id)}
            onChange={() =>
              setChecks((prev) =>
                prev.includes(action.id)
                  ? prev.filter((el) => el != action.id)
                  : [...prev, action.id]
              )
            }
          />
        ))}

        <CasinoBtnSave sx={{ mt: 2 }} onClick={onSaveClick} />
      </Stack>
    </Stack>
  );
}
